<template>
  <div
    :class="{ mobile: Base.checkSysteam() === 'MOBILE' }"
    class="protocol"
    v-if="isShow"
  >
    <div class="dialog">
      <div class="navs">
        <div
          class="nav"
          :class="{ active: current === 'user' }"
          @click="current = 'user'"
        >
          {{ $t("message.rules_clause") }}
        </div>
        <div class="divider"></div>
        <div
          class="nav"
          :class="{ active: current === 'private' }"
          @click="current = 'private'"
        >
          {{ $t("message.privacy_clause") }}
        </div>
      </div>
      <iframe :src="url" frameborder="0" class="view"></iframe>
      <div class="btns">
        <!-- <div class="btn gray" @click="handleNext(false)">不同意</div> -->
        <div class="btn" @click="handleNext(true)">
          {{ $t("message.agree") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Base from "../../utils/base";
export default {
  emits: ["settled"],
  data() {
    return {
      Base,
      current: "user",
      urls: {
        user: "https://tsource.rastargames.com/protocol/index.html?app_id=105625&cch_id=102&language=en&type=user",
        private:
          "https://tsource.rastargames.com/protocol/index.html?app_id=105625&cch_id=102&language=en&type=private",
      },
      isShow: false,
      urlData: Base.parseUrl(window.location.href),
    };
  },
  computed: {
    url() {
      return this.urls[this.current];
    },
  },
  methods: {
    handleNext(isAgree) {
      this.$emit("settled", isAgree);
      if (isAgree) {
        this.isShow = false;
      } else {
        // window.localStorage.clear();
        window.localStorage.removeItem("apiPwd");
        window.localStorage.removeItem("show");
        window.localStorage.removeItem("apiUname");
        window.localStorage.removeItem("_XH_U_WEBSDK");
        window.localStorage.removeItem("serviceUinfo");
        window.localStorage.removeItem("access_token");
        window.localStorage.removeItem("regId");
        this.$Storage.delCookie();
        if (this.system === "PC") {
          window._hmt.push(["_trackEvent", "click", "click_pcmsr_quit"]);
          this.$Report.webDotFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            "click_pcmsr_quit"
          );
        } else {
          window._hmt.push(["_trackEvent", "click", "click_momsr_quit"]);
          this.$Report.webDotFather(
            this.urlData.pid,
            this.urlData.appid,
            this.urlData.ukey,
            "click_momsr_quit"
          );
        }
        this.personal = "";
        // 成功跳转
        window.location.href = `/global/ldy/fzg?ukey=${this.urlData.ukey}&appid=${this.urlData.appid}&pid=${this.urlData.pid}&md_id=${this.urlData.md_id}`;
      }
    },
    show() {
      this.isShow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.protocol {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;

  .dialog {
    width: 463px;
    height: 405px;
    background: #fff;
    border-radius: 5px;
    padding: 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    position: relative;
    animation: dialog-appearance 0.2s;

    .close {
      position: absolute;
      top: 25px;
      right: 10px;
      width: 20px;
      height: 20px;
      cursor: pointer;
      background: url("../../assets/dialog-close.png") no-repeat center;
    }

    .navs {
      width: 100%;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      gap: 10px;

      .divider {
        width: 2px;
        height: 28px;
        background: #646464;
      }

      .nav {
        cursor: pointer;
        font-size: 15px;

        &.active {
          font-weight: bold;
        }
      }
    }

    .btns {
      display: flex;
      gap: 30px;

      .btn {
        background: linear-gradient(to right, #ed8d8a 1px, #ea6461);
        color: #fff;
        width: 148px;
        height: 54px;
        border-radius: 10px;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &.gray {
          background: linear-gradient(to right, #cccccc 1px, #bbbbbb);
        }
      }
    }

    .tip {
      font-size: 16px;
      color: #3d3d3d;
    }

    .view {
      width: 423px;
      border: 1px solid #ddd;
      flex: 1;
    }
  }

  // 移动端样式
  &.mobile {
    .dialog {
      width: 594px;
      height: 694px;
      max-height: 50vh;
      max-width: 85vw;
      overflow: hidden;

      .btns {
        max-width: 90%;

        .btn {
          height: 45px;
          flex: 1;
        }
      }
    }

    .view {
      max-width: 90%;
    }
  }
}
</style>
